<script setup>
// Table / grid switch for list pages (a shadcn-style toggle group):
//   <UiViewToggle v-model="view" />   // 'table' | 'grid'
const view = defineModel({ type: String, default: 'table' });

const options = [
  { value: 'table', icon: 'mdi-table', label: 'Table view' },
  { value: 'grid', icon: 'mdi-view-grid-outline', label: 'Grid view' },
];
</script>

<template>
  <div class="ui-view-toggle" role="radiogroup" aria-label="Layout">
    <button
      v-for="option in options"
      :key="option.value"
      type="button"
      role="radio"
      class="ui-view-toggle__btn"
      :class="{ 'is-active': view === option.value }"
      :aria-checked="view === option.value"
      :aria-label="option.label"
      @click="view = option.value"
    >
      <v-icon size="18">{{ option.icon }}</v-icon>
      <v-tooltip activator="parent" location="top" :text="option.label" />
    </button>
  </div>
</template>

<style scoped>
.ui-view-toggle {
  display: inline-flex;
  padding: 2px;
  gap: 2px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background-color: var(--background);
}
.ui-view-toggle__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 30px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: var(--muted-foreground);
  cursor: pointer;
}
.ui-view-toggle__btn:hover {
  color: var(--foreground);
}
.ui-view-toggle__btn.is-active {
  background-color: var(--accent);
  color: var(--foreground);
}
.ui-view-toggle__btn:focus-visible {
  outline: 2px solid var(--ring, var(--border));
  outline-offset: 1px;
}
</style>
